
import  { default as indexLang } from '../chinese/indexLang';
import  { default as table } from '../chinese/table';
import  { default as placeholder } from '../chinese/placeholder';
import  { default as button } from '../chinese/button';
import  { default as dialog } from '../chinese/dialog';
import  { default as home } from '../chinese/home';
import  { default as other } from '../chinese/other';
import  { default as withdraw } from '../chinese/withdraw';

export default {
    indexLang,
    table,
    placeholder,
    button,
    dialog,
    home,
    other,
    withdraw
}



// WEBPACK FOOTER //
// ./src/i18n/chinese/index.js